import React, { useCallback } from 'react';
import { Select, useSelect } from '@vtblife/uikit';

import { RealtyObjectType } from '@search/filter-enums/enums';
import { CategoryTypeFilter } from '../../../../models/Filter';

interface IMobileRealtyTypeFilterViewProps {
  filter: CategoryTypeFilter;
  handleChange: (filter: CategoryTypeFilter) => void;
  enabledSegments?: RealtyObjectType[];
  native?: boolean;
}

const selectOptions = [ {
    value: RealtyObjectType.FLAT,
    label: 'Квартиру',
    disabled: false
}, {
    value: RealtyObjectType.ROOM,
    label: 'Комнату',
    disabled: false
}, {
    value: RealtyObjectType.HOUSE,
    label: 'Дом',
    disabled: false
}, {
    value: RealtyObjectType.LAND,
    label: 'Участок',
    disabled: false
} ];

export const MobileRealtyTypeFilterView: React.FC<IMobileRealtyTypeFilterViewProps> = ({
    filter,
    handleChange,
    enabledSegments = [ RealtyObjectType.FLAT ],
    native
}) => {
    const value = filter.categoryType;

    const onChange = useCallback((next: RealtyObjectType | RealtyObjectType[]) => {
        const newValue = Array.isArray(next) ? next[0] : next;

        handleChange(new CategoryTypeFilter(newValue));
    }, [ handleChange ]);

    const options = selectOptions.map(
        option => enabledSegments.includes(option.value) ?
            option :
            { ...option, disabled: true }
    );

    const prepared = options.map(option => ({ value: option.value, text: option.label }));

    const { handleChange: handleSelectChange, is, selectedText } = useSelect(
        onChange,
        { selected: value, texts: prepared }
    );

    return (
        <Select native={native} mode='single' onChange={handleSelectChange}>
            <Select.Button size='s' dataTest='realtyType'>{selectedText}</Select.Button>
            <Select.Content>
                {options.map(option => {
                    return (
                        <Select.Option
                            dataTest={`realtyType-${option.value}`}
                            disabled={option.disabled}
                            key={option.value}
                            value={option.value}
                            selected={is(option.value)}
                        >
                            {option.label}
                        </Select.Option>
                    );
                })}
            </Select.Content>
        </Select>
    );
};
